import { ChubSettings } from './ChuB/settings'
import { ChutSettings } from './ChuT/settings'

export const settings =
  process.env.REACT_APP_THEME === 'ChuB' ? ChubSettings : ChutSettings
